import { Navigate } from "react-router-dom";

import { useOnboardingStatus } from "./useOnboardingStatus";

import { SigningInWelcomeCard } from "@/components/SigningInWelcomeCard";
import { ChooseWorkspaceAndRedirect } from "@/UserIndex";

const AuthRedirectContent = ({
  isLoading,
  shouldRedirectToWorkspace,
}: {
  isLoading: boolean;
  shouldRedirectToWorkspace: boolean;
}) => {
  if (isLoading) {
    return null;
  }

  if (shouldRedirectToWorkspace) {
    return <Navigate to="/onboarding" replace />;
  }

  return <ChooseWorkspaceAndRedirect />;
};

export const AuthRedirect = () => {
  const { isLoading, isOnboardingComplete } = useOnboardingStatus();
  const shouldRedirectToWorkspace = !isOnboardingComplete;

  return (
    <>
      <SigningInWelcomeCard />
      <AuthRedirectContent
        isLoading={isLoading}
        shouldRedirectToWorkspace={shouldRedirectToWorkspace ?? false}
      />
    </>
  );
};
